import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=1f42b0db&"
import script from "./OrderItems.js?vue&type=script&lang=js&"
export * from "./OrderItems.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports